import { render, staticRenderFns } from "./ImportProducts.vue?vue&type=template&id=6f1f4cc2&scoped=true&"
import script from "./ImportProducts.vue?vue&type=script&lang=js&"
export * from "./ImportProducts.vue?vue&type=script&lang=js&"
import style0 from "./ImportProducts.vue?vue&type=style&index=0&id=6f1f4cc2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1f4cc2",
  null
  
)

export default component.exports